export enum VerificationTaskStatusEnum {
  New = 'New',
  Active = 'Active',

  Waiting_First_Review = 'Waiting_First_Review',
  Modifications_Requested_From_First_Review = 'Modifications_Requested_From_First_Review',

  Waiting_Final_Review = 'Waiting_Final_Review',
  Modifications_Requested_From_Final_Review = 'Modifications_Requested_From_Final_Review',

  Waiting_Final_Approval = 'Waiting_Final_Approval',

  Final_Report_Approved = 'Final_Report_Approved',
  Final_Report_Rejected = 'Final_Report_Rejected',

  Overdue = 'Overdue',

  Escalate_To_Related_Entity = 'Escalate_To_Related_Entity'
}

